import type {
  CosmicProductType,
  CosmicVariationType,
} from '@/lib/cms/cosmic/types/CosmicProductType'
import { sendGTMEvent } from '@next/third-parties/google'
import { getTerms } from '@/lib/hooks/services/useGetTerms'
import type { GtmGlobalStoreProps } from '../../useGTM'

export type GtmProductsDetailLinkCopiedType = {
  productVariation: CosmicVariationType
  product: CosmicProductType
  type: string
}

export const gtmProductDetailLinkCopied = ({
  product,
  productVariation,
  globalStore,
  type,
}: GtmProductsDetailLinkCopiedType & GtmGlobalStoreProps) => {
  const {
    user: { customerType },
    app: { marketExceptions },
  } = globalStore

  if (!productVariation) return
  if (!product) return

  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_product_detail_link_copied',
    event_id: uuid,
    item_sku: productVariation.sku,
    item_brand: 'Unicity',
    item_name: product.name,
    category: product.categories && product.categories[0]?.name,
    ship_by: undefined,
    price:
      productVariation.pricing &&
      getTerms({
        pricingData: productVariation.pricing,
        forCustomerType: customerType,
      })?.priceEach,
    currency: marketExceptions?.currencyCode,
    customer_type: customerType,
    focused_link: type === 'focus',
  })
}
